"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useMyInformation = void 0;
var _auth = require("@ori/auth");
var _checkoutUtils = require("@ori/checkout-utils");
var _globalApiClientReact = require("@ori/global-api-client-react");
var _shoppingContext = require("@ori/shopping-context");
var _contexts = require("../../contexts");
var _logger = require("../../logger");
const useMyInformation = () => {
  const {
    isLoaded,
    isLoading,
    shoppingContext: {
      customerId = _auth.NOT_LOGGED_IN_USER_ID,
      shoppingBagOwnerName = ''
    } = {}
  } = (0, _shoppingContext.useShoppingContext)();
  const {
    areCustomerCheckoutPrerequisitesLoading,
    customerCheckoutPrerequisites: {
      email,
      telephone
    }
  } = (0, _contexts.useNavigationContext)();
  const swrOptionsEmails = {
    onSuccess: () => {
      (0, _logger.logDebug)('useGetCustomerEmails() request finished successfully');
    },
    ..._checkoutUtils.errorHandlingSwrOptions
  };
  const swrOptionsPhones = {
    onSuccess: () => {
      (0, _logger.logDebug)('useMyInformation() request finished successfully');
    },
    ..._checkoutUtils.errorHandlingSwrOptions
  };
  const {
    data: {
      emails = []
    } = {},
    isValidating: areCustomerEmailsLoading
  } = (0, _globalApiClientReact.useGetCustomerEmails)(customerId, undefined, {
    swr: swrOptionsEmails
  });
  const {
    data: {
      telephonesCollection = []
    } = {},
    isValidating: areCustomerPhonesLoading
  } = (0, _globalApiClientReact.useGetCustomerPhones)(customerId, undefined, {
    swr: swrOptionsPhones
  });
  const emailAddress = emails[0]?.emailAddress;
  const phoneNumber = telephonesCollection.find(phone => phone.isPrimary)?.telephoneNumber;
  const isEmailMissingMessageVisible = Boolean(email?.isMandatory && (email.isMissing || !emailAddress));
  const isPhoneMissingMessageVisible = Boolean(telephone?.isMandatory && (telephone.isMissing || !phoneNumber));
  const urlParams = new URLSearchParams(window.location.search);
  const store = urlParams.get('store');
  const profileLink = store ? `/mypages/profile?store=${store}#/contact` : '/mypages/profile';
  const isShoppingContextLoading = isLoading && !isLoaded;
  const isQueryLoading = isShoppingContextLoading || areCustomerEmailsLoading || areCustomerPhonesLoading || areCustomerCheckoutPrerequisitesLoading;
  const myInformationContentProps = {
    emailAddress,
    isEmailMissingMessageVisible,
    isPhoneMissingMessageVisible,
    phoneNumber,
    profileLink,
    shoppingBagOwnerName
  };
  return {
    myInformationContentProps,
    isQueryLoading
  };
};
exports.useMyInformation = useMyInformation;